import { format } from "date-fns";
import { PlusCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { DateRange } from "react-day-picker";

import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { cn } from "@/lib/utils";

type DateRangeFilterProps = {
  date: DateRange | undefined;
  setDate: (date: DateRange | undefined) => void;
};

export function DateRangeFilter({ date, setDate }: DateRangeFilterProps) {
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [dateRange, setDateRange] = useState<DateRange | undefined>(date);

  useEffect(() => {
    setDateRange(date);
  }, [date]);

  return (
    <Popover open={isDatePickerOpen} onOpenChange={setIsDatePickerOpen}>
      <PopoverTrigger asChild>
        <Button
          variant={date ? "default" : "outline"}
          className={cn(
            "gap-2 border border-border ring-0",

            !date?.from && !date?.to && "border-dashed text-muted-foreground",
          )}
        >
          {!date?.from && !date?.to && (
            <PlusCircle className="size-4 flex-shrink-0" aria-hidden={true} />
          )}
          {date?.from ? (
            date.to ? (
              <>
                {format(date.from, "PP")} - {format(date.to, "PP")}{" "}
              </>
            ) : (
              format(date.from, "PP")
            )
          ) : (
            "Select a date"
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <Calendar
          mode="range"
          selected={dateRange}
          onSelect={(date) => {
            setDateRange(date);
          }}
        />
        <div className="flex justify-between px-2 py-3">
          <Button
            onClick={() => {
              setIsDatePickerOpen(false);
              setDate(undefined);
              setDateRange(undefined);
            }}
            variant="ghost"
          >
            Clear
          </Button>
          <Button
            onClick={() => {
              setIsDatePickerOpen(false);
              setDate(dateRange);
            }}
          >
            Update
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
